import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
`;

export const Trigger = styled.button`
  display: flex;
  align-items: center;
  gap: 0.35rem;
  background: transparent;
  border: none;
  color: var(--background-button-component);
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  padding: 0.25rem 0;

  &:hover {
    text-decoration: underline;
  }

  svg {
    font-size: 1.1rem;
  }
`;

export const Dropdown = styled.div<{ $open: boolean }>`
  position: absolute;
  left: 0;
  top: calc(100% + 0.35rem);
  min-width: 240px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(14, 34, 68, 0.16);
  z-index: 30;
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  transform: ${({ $open }) => ($open ? 'scale(1)' : 'scale(0.96)')};
  pointer-events: ${({ $open }) => ($open ? 'auto' : 'none')};
  transition: opacity 0.2s ease, transform 0.2s ease;
  transform-origin: top right;

  .dropdown-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    border-bottom: 1px solid #e8e8e8;

    h2 {
      margin: 0;
      font-size: 0.85rem;
      font-weight: 700;
      color: var(--background-button-component);
    }

    .direction-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--background-button-component);
      color: #fff;
      border: none;
      border-radius: 6px;
      padding: 0.35rem 0.55rem;
      cursor: pointer;
      transition: filter 0.2s;

      &:hover {
        filter: brightness(1.1);
      }
    }
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0.35rem 0;

    li button {
      width: 100%;
      text-align: left;
      background: transparent;
      border: none;
      padding: 0.6rem 1rem;
      font-size: 0.875rem;
      color: #333;
      cursor: pointer;

      &:hover,
      &.active {
        background: #f3f5f8;
        color: var(--background-button-component);
        font-weight: 600;
      }
    }
  }

  .dropdown-footer {
    display: flex;
    justify-content: flex-end;
    padding: 0.5rem 1rem 0.75rem;

    .apply-btn {
      background: var(--background-button-component);
      color: #fff;
      border: none;
      border-radius: 6px;
      padding: 0.45rem 1rem;
      font-size: 0.8rem;
      font-weight: 700;
      cursor: pointer;
      transition: filter 0.2s;

      &:hover {
        filter: brightness(1.1);
      }
    }
  }
`;
